import React from "react";
import "./themeInput.css";

const ThemeInput = ({ placeholder, type, className, value, onChange, onBlur }) => {
  return (
    <div className="theme-input">
      <input
        className={`form-control input-item ${className}`}
        placeholder={placeholder}
        type={type}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
      />
    </div>
  );
};

export default ThemeInput;
